<template>
  <div
    class="x-layout-container x-layout-container-ml-[calc(142px+48px)] x-layout-container-mr-[calc(40px+48px)]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
<style scoped lang="scss"></style>
